module.exports = __webpack_public_path__ + "static/media/21_B.a558eee6.png";